export const authKeys = {
  session: () => ["auth", "session"] as const,
};
